(ns app.survey.login.email.view
  (:require
   [app.survey.login.email.event :as event]
   [app.survey.login.email.state :as state]
   [app.survey.login.email.sub :as sub]
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.loading-spinner.view :as spinner]
   [ui.editors.data-input :as data-input]))


(defn email-token-block
  []
  (let [masked-email @(rf/subscribe [::sub/masked-email])
        token @(rf/subscribe [::sub/email-token])]
    [:div
     {:class "flex flex-col gap-2"}
     [:label
      {:class "font-semibold text-base-regular-text"}
      (loc/tr :token-from-email [masked-email])]
     [data-input/view
      {:data-type :data.type/text-simple
       :value     token
       :on-change (fn [v]
                    (rf/dispatch [::event/edit-email-token (cu/str-trim v)]))}]]))

(defn email-token-buttons-block
  []
  (let [valid-email-token? @(rf/subscribe [::sub/valid-email-token?])]
    [:div
     {:class "py-6 flex flex-col gap-1"}
     [button/primary-solid
      {:on-click  #(rf/dispatch [::event/submit-email-token])
       :disabled? (or (not valid-email-token?))}
      (loc/tr :submit)]
     [:div
      {:class-name "relative flex items-center mt-2"}
      [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]
      [:span {:class-name "flex-shrink mx-4 text-complement-light-text text-xs"} "OR"]
      [:div {:class-name "flex-grow border-t border-solid border-complement-light-border"}]]
     [button/secondary-open
      {:on-click #(rf/dispatch [::event/cancel-login-process])}
      (loc/tr :cancel)]
     ]))

(defn email-sent-view
  []
  [:<>
   [email-token-block]
   [email-token-buttons-block]])

(defn processing
  []
  [:<>
   [:div
    {:class "flex flex-col"}
    [spinner/circle]]])

(defn view
  []
  (rf/dispatch [::event/init])
  (fn []
    (let [state @(rf/subscribe [::sub/state])]
      (js/console.log "Email login view : " state)
      [:<>
       (case state
         ::state/submitting-email
         [processing]
         ::state/sent-email-token
         [email-sent-view]
         ::state/submitting-email-token
         [processing]
         [processing])])))
